<template>
  <div class="home-shell" :class="{ 'home-shell--console-fullscreen': danmuConsoleFullscreen && page === 'appDanmuConsole' }" style="height:100%;width:100vw;display: flex;flex-direction: row">
	  <el-row class="home-sidebar" style="height:100%;width:15vw;">
	    <el-col :span="12" style="height: 100%;overflow: hidden;width:100%;" class="demo">
	         <div style="width:15vw;height:8vh;display: flex;align-items: center;justify-content: center;background-color: #191a23;color:white;position: fixed;top:0;">
				快乐星姬天制作委员会
			</div>
			<div style="width:100%;height:8vh;display: flex;align-items: center;justify-content: center;background-color: #191a23;color:white">
				
			</div>
	        <el-menu
			  style="height: 92vh;width:100%;overflow-y: auto;overflow-x: hidden;"
	          default-active="0"
	          class="el-menu-vertical-demo"
	          background-color="#191a23"
	          text-color="#fff"
	          active-text-color="#3c9cff">  
			  <div  v-for="(item,index) in pagelist" :key="index">
	          <el-submenu  v-if="item.type==2" :index="index+''"
			
			  >
					<template slot="title">
					  <i :class="item.icon"></i>
					  <span>{{item.title}}</span>
					</template>
					<el-menu-item-group>
					  <el-menu-item   @click="page=item1.page" :index="(index+1)+'-'+(index1+1)" v-for="(item1,index1) in item.list" :key="item1.page || index1">{{item1.title}}</el-menu-item>
					</el-menu-item-group>
					<!---->
	           </el-submenu>
				<el-menu-item :index="index+''"  v-if="item.type==1"   @click="page=item.page">
				    <i :class="item.icon"></i>
				    <span slot="title">{{item.title}}</span>
				</el-menu-item> 
				</div>
	        </el-menu>
	      </el-col>
	  </el-row>
	  
	<div class="home-main" style="width:85vw;heigth:100vh;background-color: #fafafa;display: flex;flex-direction: column;">
		<index1 style="width: 100%;height: 100%;" v-if="page=='home'"></index1>
		<message style="width: 100%;height: 100%;" v-if="page=='message'"></message>
		<video1 style="width: 100%;height: 100%;" v-if="page=='video'"></video1>
		<info style="width: 100%;height: 100%;" v-if="page=='info'"></info>
		<xjt style="width: 100%;height: 100%;" v-if="page=='xjt'"></xjt>
		<user style="width: 100%;height: 100%;" v-if="page=='user'"></user>
		<image1 style="width: 100%;height: 100%;" v-if="page=='image1'"></image1>
		<image2 style="width: 100%;height: 100%;" v-if="page=='image2'"></image2>
		<theme style="width: 100%;height: 100%;" v-if="page=='theme'"></theme>
		<gift style="width: 100%;height: 100%;" v-if="page=='gift'"></gift>
		<date style="width: 100%;height: 100%;" v-if="page=='date'"></date>
		<notice style="width: 100%;height: 100%;" v-if="page=='notice'"></notice>
		<app-dashboard style="width: 100%;height: 100%;" v-if="page=='appDashboard'"></app-dashboard>
		<app-preview style="width: 100%;height: 100%;" v-if="page=='appPreview'"></app-preview>
		<app-users style="width: 100%;height: 100%;" v-if="page=='appUsers'"></app-users>
		<forum-category style="width: 100%;height: 100%;" v-if="page=='forumCategory'"></forum-category>
		<forum-posts style="width: 100%;height: 100%;" v-if="page=='forumPosts'"></forum-posts>
		<forum-reports style="width: 100%;height: 100%;" v-if="page=='forumReports'"></forum-reports>
		<app-wgt style="width: 100%;height: 100%;" v-if="page=='appWgt'"></app-wgt>
		<app-apk style="width: 100%;height: 100%;" v-if="page=='appApk'"></app-apk>
		<app-skin style="width: 100%;height: 100%;" v-if="page=='appSkin'"></app-skin>
		<app-voice style="width: 100%;height: 100%;" v-if="page=='appVoice'"></app-voice>
		<app-logs style="width: 100%;height: 100%;" v-if="page=='appLogs'"></app-logs>
		<app-bilibili style="width: 100%;height: 100%;" v-if="page=='appBilibili'"></app-bilibili>
		<app-bilibili-push style="width: 100%;height: 100%;" v-if="page=='appBilibiliPush'"></app-bilibili-push>
		<app-week-schedule style="width: 100%;height: 100%;" v-if="page=='appWeekSchedule'"></app-week-schedule>
		<app-astrbot style="width: 100%;height: 100%;" v-if="page=='appAstrbot'"></app-astrbot>
		<runtime-logs style="width: 100%;height: 100%;" v-if="page=='runtimeLogs'"></runtime-logs>
		<app-danmu-console style="width: 100%;height: 100%;" v-if="page=='appDanmuConsole'" @fullscreen-change="setDanmuConsoleFullscreen"></app-danmu-console>
		<app-danmakus style="width: 100%;height: 100%;" v-if="page=='appDanmakus'"></app-danmakus>
		<game-manage style="width: 100%;height: 100%;" v-if="page=='gameManage'"></game-manage>
	</div>
  </div>
</template>
<script>
import { post } from "../axios/request.js"
import index1 from "@/components/index.vue"
import message from "@/components/message.vue"
import video1 from "@/components/video.vue"
import info from "@/components/info.vue"
import xjt from "@/components/xjt.vue"
import image1 from "@/components/image1.vue"
import image2 from "@/components/image2.vue"
import user from "@/components/user.vue"
import theme from "@/components/theme.vue"
import gift from  "@/components/gift.vue"
import date from  "@/components/date.vue"
import notice from  "@/components/notice.vue"
import appDashboard from "@/components/appDashboard.vue"
import appPreview from "@/components/appPreview.vue"
import appUsers from "@/components/appUsers.vue"
import forumCategory from "@/components/forumCategory.vue"
import forumPosts from "@/components/forumPosts.vue"
import forumReports from "@/components/forumReports.vue"
import appWgt from "@/components/appWgt.vue"
import appApk from "@/components/appApk.vue"
import appSkin from "@/components/appSkin.vue"
import appVoice from "@/components/appVoice.vue"
import appLogs from "@/components/appLogs.vue"
import appBilibili from "@/components/appBilibili.vue"
import appBilibiliPush from "@/components/appBilibiliPush.vue"
import appWeekSchedule from "@/components/appWeekSchedule.vue"
import appAstrbot from "@/components/appAstrbot.vue"
import runtimeLogs from "@/components/runtimeLogs.vue"
import appDanmuConsole from "@/components/appDanmuConsole.vue"
import appDanmakus from "@/components/appDanmakus.vue"
import gameManage from "@/components/gameManage.vue"
export default {
components: { 
	index1,message,video1,info,xjt,image1,image2,user,theme,gift,date,notice,appDashboard,appPreview,appUsers,forumCategory,forumPosts,forumReports,appWgt,appApk,appSkin,appVoice,appLogs,appBilibili,appBilibiliPush,appWeekSchedule,appAstrbot,runtimeLogs,appDanmuConsole,appDanmakus,gameManage
	},
	data() {
		return {
		page:'home',
		danmuConsoleFullscreen: false,
		timer:null,
		pagelist:[
			{
				type:2,
				title:"粉丝站",
				icon:"el-icon-s-home",
				list:[
					{
						title:"首页",
						page:"home"
					},
					{
						title:"留言管理",
						page:"message"
					},
					{
						title:"切片管理",
						page:"video"
					},
					{
						title:"文章管理",
						page:"theme"
					},
					{
						title:"百科管理",
						page:"info"
					},
					{
						title:"舰礼管理",
						page:"gift"
					},
					{
						title:"日程表管理",
						page:"date"
					},
					{
						title:"公告管理",
						page:"notice"
					},
					{
						title:"素材文件",
						page:"image1"
					},
					{
						title:"表情包",
						page:"image2"
					},
					{
						title:"星姬天故事",
						page:"xjt"
					},
					{
						title:"星姬天列表",
						page:"user"
					},
				]
			},
			{
				type:2,
				title:"APP端",
				icon:"el-icon-mobile-phone",
				list:[
					{
						title:"APP仪表盘",
						page:"appDashboard"
					},
					{
						title:"APP用户管理",
						page:"appUsers"
					},
					{
						title:"论坛分类管理",
						page:"forumCategory"
					},
					{
						title:"论坛帖子管理",
						page:"forumPosts"
					},
					{
						title:"举报管理",
						page:"forumReports"
					},
					{
						title:"WGT发布",
						page:"appWgt"
					},
					{
						title:"APK发布",
						page:"appApk"
					},
					{
						title:"APP皮肤管理",
						page:"appSkin"
					},
					{
						title:"璇宝语音",
						page:"appVoice"
					},
					{
						title:"操作日志",
						page:"appLogs"
					},
					{
						title:"B站登录",
						page:"appBilibili"
					},
				]
			},
			{
				type:1,
				title:"全局运行日志",
				icon:"el-icon-document",
				page:"runtimeLogs"
			},
			{
				type:1,
				title:"APP预览",
				icon:"el-icon-view",
				page:"appPreview"
			},
			{
				type:1,
				title:"弹幕控制台",
				icon:"el-icon-s-data",
				page:"appDanmuConsole"
			},
			{
				type:1,
				title:"Danmakus",
				icon:"el-icon-chat-line-round",
				page:"appDanmakus"
			},
			{
				type:2,
				title:"机器人管理",
				icon:"el-icon-cpu",
				list:[
					{
						title:"AstrBot后台",
						page:"appAstrbot"
					},
					{
						title:"B站推送",
						page:"appBilibiliPush"
					},
					{
						title:"周表管理",
						page:"appWeekSchedule"
					},
				]
			},
			{
				type:2,
				title:"游戏管理",
				icon:"el-icon-trophy",
				list:[
					{
						title:"doro璇养成屋",
						page:"gameManage"
					},
				]
			},
			
		]
	}
  },
  watch: {
	page() {
		this.danmuConsoleFullscreen = false;
	},
  },
  mounted() {
	let that=this;
	post("/api/admin/jugetoken",{token:localStorage.getItem("token")}).then((res)=>{
            if(res.data.code==1002){
				that.$router.replace({path:"/"})
            }else{
                
            }
    })
	setInterval(()=>{
		 post("/api/admin/jugetoken",{token:localStorage.getItem("token")}).then((res)=>{
            if(res.data.code==1002){
				that.$router.replace({path:"/"})
            }else{
                
            }
        })
	},1000*60)
  },
  methods: {
	changepage(e){
		this.page=e;
	},
	setDanmuConsoleFullscreen(value){
		this.danmuConsoleFullscreen = !!value;
	},
  },
}
</script>
<style>
.demo {
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}
.home-shell--console-fullscreen .home-sidebar {
  display: none !important;
}
.home-shell--console-fullscreen .home-main {
  width: 100vw !important;
}
body{
	height:100vh;
	padding:0;
	margin:0;
	overflow: hidden;
}
.el-menu {
  overflow: -moz-scrollbars-none;  /* Firefox */
  -ms-overflow-style: none;        /* Internet Explorer 10+ */
  scrollbar-width: none;           /* Firefox */
}
/*找到滚动条在谁身上 设置下面的属性*/
.el-menu::-webkit-scrollbar {
  display: none;  /* Chrome, Safari, Opera */
}
</style>
